import { InputNumber } from "primereact/inputnumber";

// Icons
import { TbPigMoney } from "react-icons/tb";

// Types
import type { IBuildProps } from "./types";

export function Build({ADM_FEE,BUILD_AMOUNT,idealAreaBuild,  TOTAL_BUILD,setIdealAreaBuild}: IBuildProps) {

    return (<span style={{
                maxWidth: 'calc(50% - 0.75rem)',
                minWidth: 'calc(50% - 0.75rem)',
            }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-between gap-3
                    rounded-xl
                    border-slate-200 border-[1px]
                    bg-white shadow-md overflow-hidden
                "
            >
                <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                    <TbPigMoney size={25} />
                    <span className="font-semibold">Obra</span>
                </span>

                <span className="w-full h-auto flex flex-col gap-3 p-4">
                    <span className="w-full h-auto flex flex-row items-center justify-between gap-4">
                        <span>Tamanho da Casa (m²)</span>
                        <InputNumber
                            mode="decimal"
                            locale="pt-BR"
                            minFractionDigits={2}
                            value={idealAreaBuild}
                            onValueChange={(e) => setIdealAreaBuild(e.value || 0)}
                        />
                    </span>

                    {/* <span className="w-full h-auto flex flex-row items-center justify-between">
                        <span>Entrada (volta no financ.)</span>
                        <InputNumber
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            minFractionDigits={2}
                            value={0}
                            // onValueChange={(e) => setEntryAmount(e.value || 0)}
                        />
                        <span className="font-semibold">
                            {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    unitDisplay: 'long'
                                }).format(entryAmount)
                            }
                        </span>
                    </span> */}

                    <span className="w-full h-auto flex flex-row items-center justify-between">
                        <span>Valo da construção</span>
                        {/* <span className="font-semibold">
                            {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'percent',
                                    unitDisplay: 'long'
                                }).format(ITBI)
                            }
                        </span> */}
                        <span className="font-semibold">
                            {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    currencyDisplay: 'symbol'
                                }).format(BUILD_AMOUNT)
                            }
                        </span>
                    </span>

                    <span className="w-full h-auto flex flex-row items-center justify-between">
                        <span>Taxa de ADM</span>
                        <span className="font-semibold">
                            {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    currencyDisplay: 'symbol'
                                }).format(ADM_FEE)
                            }
                        </span>
                    </span>
                </span>

                <span className="w-[90%] self-end h-auto flex flex-col items-end gap-2 bg-slate-200 p-4">
                    {/* <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                currencyDisplay: 'symbol'
                            }).format(0)
                        }
                    </span> */}
                    <span className="w-full flex flex-row items-center justify-end gap-5">
                        <span className="font-bold">Total</span>
                        <span className="font-bold">
                            {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    currencyDisplay: 'symbol'
                                }).format(TOTAL_BUILD)
                            }
                        </span>
                    </span>
                </span>
            </span>
    )
}
